import React, { useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import Slider from 'react-slick';
import "./calendario.css";
import 'react-calendar/dist/Calendar.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import arcoiris from 'assets/images/red-arcoiris.png';
import personajes_1 from 'assets/images/red-personajes-1.png';

import Cardescuela from '../../components/ui/cardescuela'
import './index.css';

import {calendariodataescuela} from '../../utils';

function Calendario() {
  const [date, setDate] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const sliderRef = React.createRef();
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await calendariodataescuela();
        setData(result);
      } catch (error) {
        console.error("Error fetching calendar data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  function parseDateAsUTC(dateString) {
    const date = new Date(dateString + 'T12:00:00Z');
    return date;
  }
  const onDateChange = date => {
    setDate(date);
    const index = data.findIndex(event => parseDateAsUTC(event.fecha).toDateString() === date.toDateString());
    if (index !== -1 && sliderRef.current) {
      sliderRef.current.slickGoTo(index);
    }
  };

  if (loading || !data.length) {
    return <div></div>;
  }

  const settings = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        }
      }
    ]
  };

  
  const activeDates = data.map(event => parseDateAsUTC(event.fecha));

  const next = () => {
    sliderRef.current.slickNext();
  };
  const previous = () => {
    sliderRef.current.slickPrev();
  };

  return (
    <article className="ricoendata-calendario" id='ricoendata-calendario'>
      <div className="wrapper">
        <img className="elem arcoiris" src={arcoiris} alt="" />
        <img className="elem personajes_1" src={personajes_1} alt="" />
        <h3>CALENDARIO DE ESCUELAS</h3>
        <div className='columns calendario'>
          <div className='col col1'>
            <h5>Seleccioná una fecha<br />para conocer las visitas a los Colegios</h5>
            <Calendar
              onChange={onDateChange}
              value={date}
              defaultView="month"
              activeStartDate={parseDateAsUTC(data[0].fecha)}
              
              locale="es-ES"
              minDetail="month"
              prevLabel={<span>‹</span>}
              nextLabel={<span>›</span>}
              maxDate={parseDateAsUTC(data[0].fecha)}
              minDate={parseDateAsUTC(data[data.length-1].fecha)}
              tileDisabled={({ date }) => !activeDates.some(d => d.toDateString() === date.toDateString())}
            />
          </div>
          <div className='col col2'>
            <div className="cards">
              <Slider  ref={sliderRef} {...settings}>
                { data.map((item => <Cardescuela key={item.id} data={item} />)) }
              </Slider>
              <div className='slick-buttons'>
                <button onClick={previous}><span>‹</span></button>
                <button onClick={next}><span>›</span></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}

export default Calendario;
